import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {ConfigService} from './config/config.service';
import {BimModel} from '@mydocma/bim-viewer';
import {BimSection, PlanDto} from './models/plan';
import {joinUrl} from '@docma-mm-core/utils/utils';

@Injectable({providedIn: 'root'})
export class BpApiService {
  private readonly apiUrl;

  constructor(private http: HttpClient, private bpConfigService: ConfigService) {
    this.apiUrl = this.bpConfigService.getConfig().bpApiUrl;

  }


  public getDefaultModel(): Observable<BimModel[]> {
    const api = joinUrl(this.apiUrl, '/bim-models?default=true');
    return this.http.get<BimModel[]>(api);
  }

  // bim plan extends plan contain transform object

  public getBimSections(bimModelId: string): Observable<BimSection[]> {
    const api = joinUrl(this.apiUrl, `bim-models/${bimModelId}/floor-plans?details=true`);
    const bimSections = this.http.get<BimSection[]>(api);
    return bimSections;
  }


  public getPlans(projectId: string): Observable<PlanDto[]> {
    const url = joinUrl(this.apiUrl, `plans`);
    return this.http.get<PlanDto[]>(url)
    .pipe(
      map(plans => {
        const plansWithVersion = [];
        plans.forEach(p => {
          const planVersions = p.versions?.filter(x => x.status === 'calibrated')?.sort((a, b) => b.version - a.version);
          if (planVersions?.length > 0) {
            p.activeVersion = planVersions[0];
            plansWithVersion.push(p);
          }

        });
        return plansWithVersion;
      }
      )
    );
  }

  public getPlanById(id: string): Observable<PlanDto> {
    const url = joinUrl(this.apiUrl, `plans/${id}`);
    return this.http.get<PlanDto>(url)
    .pipe(
      map((plan: any) => {
        plan.activeVersion = plan.versions[plan.versions.length - 1];
        return plan;
      }
      )
    );
  }

  public getPlanByUrl(url: string): Observable<Blob>{
    return this.http.get(url, {responseType: 'blob'});
  }
}
